import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { SubmissionError } from 'redux-form';
import PropTypes from 'prop-types';

import { login, changeManagedServicesUserPassword } from 'redux/actions/userActions';
import LogInForm from 'components/LogInForm';
import logoBlue from 'images/logo/logo_blue.svg';
import { MAX_MEDIUM_SIZE } from 'constants/misc';
import Casely from 'images/partners/Casely';
import Crossrope from 'images/partners/Crossrope';
import TenthStreet from 'images/partners/TenthStreet';
import Joovy from 'images/partners/Joovy';
import KeySmart from 'images/partners/KeySmart';
import Rocketbook from 'images/partners/Rocketbook';
import { redirectApp } from 'utils/misc';


const DashboardImg = `${process.env.PUBLIC_URL}/img/login_dashboard.svg`;
const checkIsSignUp = location => location.pathname.includes('/signup/managed-service');

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.secondary.background,
    minHeight: '100vh',
    width: '100%',
  },
  wrapper: props => ({
    paddingTop: checkIsSignUp(props.location) ? '50px' : '104px',
    width: '1080px',
    maxWidth: '80%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 auto',
    [`@media screen and (max-width: ${MAX_MEDIUM_SIZE}px)`]: {
      justifyContent: 'center',
    },
  }),
  right: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [`@media screen and (max-width: ${MAX_MEDIUM_SIZE}px)`]: {
      display: 'none',
    },
  },
  formWrapper: {
    width: '528px',
  },
  usedBy: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '65%',
    marginTop: '1rem',
  },
  partnerLogo: {
    color: theme.palette.secondary['400'],
    height: '4rem',
  },
  caselyLogo: {
    width: '6rem',
  },
  crossropeLogo: {
    width: '7rem',
  },
  tenthstreetLogo: {
    width: '7rem',
  },
  joovyLogo: {
    width: '5rem',
  },
  keySmartLogo: {
    width: '6rem',
  },
  rocketbookLogo: {
    width: '8rem',
  },
});

class LogIn extends PureComponent {
  onSubmit = async (formData) => {
    try {
      await this.props.login({
        email: formData.email,
        password: formData.password,
      });
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError({ password: 'Password or email invalid', _error: 'Login failed!' });
      }
    }
  }

  /* eslint-disable class-methods-use-this */
  onSignUp = async (formData) => {
    const { subscription } = this.props;
    try {
      await this.props.changeManagedServicesUserPassword({
        chargebee_customer_id: subscription.chargebee_data.customer_id,
        email: formData.email,
        company: formData.company,
        first_name: formData.firstName,
        last_name: formData.lastName,
        phone: formData.phone,
        password: formData.password,
      });
      redirectApp('/');
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError({ password: 'Password or email invalid', _error: 'Login failed!' });
      }
    }
  }

  render() {
    const { classes, isSignUp } = this.props;
    // eslint-disable-next-line consistent-return
    const onFormSubmit = isSignUp ? this.onSignUp : this.onSubmit;

    return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <div className={classes.formWrapper}>
            <img src={logoBlue} alt="PR Volt logo" />
            <LogInForm onSubmit={onFormSubmit} isSignUp={isSignUp} />
          </div>
          <div className={classes.right}>
            <img src={DashboardImg} alt="Dashboard" />
            <div className={classes.usedBy}>
              <Joovy className={`${classes.partnerLogo} ${classes.joovyLogo}`} viewBox="0 0 80 37" />
              <Rocketbook className={`${classes.partnerLogo} ${classes.rocketbookLogo}`} viewBox="0 0 154 24" />
              <Crossrope className={`${classes.partnerLogo} ${classes.crossropeLogo}`} viewBox="0 0 140 15" />
              <TenthStreet className={`${classes.partnerLogo} ${classes.tenthstreetLogo}`} viewBox="0 0 118 23" />
              <KeySmart className={`${classes.partnerLogo} ${classes.keySmartLogo}`} viewBox="0 0 109 16" />
              <Casely className={`${classes.partnerLogo} ${classes.caselyLogo}`} viewBox="0 0 107 44" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LogIn.propTypes = {
  login: PropTypes.func.isRequired,
  changeManagedServicesUserPassword: PropTypes.func.isRequired,
  classes: PropTypes.element.isRequired,
  isSignUp: PropTypes.bool,
};

LogIn.defaultProps = {
  isSignUp: false,
};

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(
    (state, props) => ({
      user: state.user,
      isSignUp: checkIsSignUp(props.location),
      subscription: state.subscription,
    }),
    { login, changeManagedServicesUserPassword },
  ),
)(LogIn);
